import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { Heidari_data } from '../../assets'

const AlirezaHeidari = () => {
  return (
    <>
    <PanelMemberTemplate {...Heidari_data}/>
    </>
  )
}

export default AlirezaHeidari
